// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"redirect_wrapper__1cQN4"};